import React from 'react';
import PropTypes from 'prop-types';

var SvgContextMixin = require('./svgContextMixin');
var SvgChartContextMixin = require('./svgChartContextMixin');

var SvgChartLinkedLegendPath = React.createClass({
  mixins: [SvgContextMixin, SvgChartContextMixin],

  statics: {
    id: "ChartLinkedLegendPath-",
    strokeWidth: "0.7",
    strokeDasharray: "5, 2"
  },

  propTypes: {
    edgePoint: PropTypes.object.isRequired,
    labelPoint: PropTypes.object.isRequired,
    itemWidth: PropTypes.number,
    itemHeight: PropTypes.number
  },

  getDefaultProps(){
    return {
      color: "#000000"
    };
  },

  render(){
    var {chartId, edgePoint, labelPoint, color} = this.props;

    return (
      <g id={SvgChartLinkedLegendPath.id  + chartId}>
        {this._getPathLine(edgePoint, labelPoint, color)}
      </g>
    );
  },

  _getPathLine(edgePoint, labelPoint, color){
    var x1, y1, x2, y2;
    [x1, y1] = this.context.getPoint(edgePoint.x, edgePoint.y);
    x2 = this.context.relativeX(labelPoint.x);
    y2 = this.context.relativeY(labelPoint.y);

    return this.getCurvedLine(x1, y1, x2, y2, color);
  },

  getLine(x1, y1, x2, y2, color){
      return (
        <line
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke={color}
            strokeWidth={SvgChartLinkedLegendPath.strokeWidth}
            strokeDasharray={SvgChartLinkedLegendPath.strokeDasharray}
        />
      );
  },

  curvedHorizontal(x1, y1, x2, y2){
    var line = []
    var mx = x1 + (x2 - x1) * 0.8

    line.push('M', x1, y1)
    line.push('C', mx, y1, mx, y2, x2, y2)

    return line.join(' ')
  },

  getCurvedLine(x1, y1, x2, y2, color){
    var coord = this.curvedHorizontal(x1, y1, x2, y2);
    return (
        <path
            d={coord}
            stroke={color}
            strokeWidth={SvgChartLinkedLegendPath.strokeWidth}
            fill="none"
            strokeDasharray={SvgChartLinkedLegendPath.strokeDasharray}
        />
      )
  }
});


module.exports = SvgChartLinkedLegendPath;
